/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { isBrowser, isMobile } from 'react-device-detect';
import { useQuery } from 'react-query';
import { CardSettingsContext } from '../../../../contexts/card/settings/context';
import {
  useCardStatus,
  useUserCardProvider,
  useUserPersonalInfo,
} from '../../../../utilities/sharedHooks/user';
import { GenericLoading } from '../../../../components/Placeholders';
import { useCardHolderNameForUser } from '../../../../utilities/sharedHooks/card';
import { ACCOUNT_MAILING_ADDRESSES } from '../../../../utilities/sharedQueries';

const MainLayout = ({ children = null, className = '' }) => {
  const { state, updateUser, updateUserCardStatus, openScreen } = useContext(CardSettingsContext);

  const { cardProvider } = useUserCardProvider();
  const { isUS, firstName, lastName } = useUserPersonalInfo();

  const history = useHistory();
  const { state: locationState } = useLocation();

  const { data: cardStatus, isLoading: isLoadingCardStatus } = useCardStatus();

  const [userFirstName, userLastName] = useCardHolderNameForUser({
    first_name: firstName,
    last_name: lastName,
  });
  const { data: mailingAddresses, isLoading: isLoadingMailingAddresses } =
    useQuery(ACCOUNT_MAILING_ADDRESSES);

  useEffect(() => {
    if (!locationState?.initScreen) {
      history.push('/dashboard/card/details');
    }
  }, []);

  useEffect(() => {
    openScreen(locationState?.initScreen);
  }, [locationState?.initScreen]);

  useEffect(() => {
    updateUser({
      cardProvider,
      isUS,
      firstName: userFirstName,
      lastName: userLastName,
      mailingAddresses,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardProvider, isUS]);

  useEffect(() => {
    if (!state?.cardStatus && cardStatus) {
      updateUserCardStatus(cardStatus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.cardStatus, cardStatus]);

  const renderedComponent = useMemo(() => {
    if (
      !cardProvider ||
      !state?.currentScreen ||
      isLoadingCardStatus ||
      !locationState?.initScreen ||
      isLoadingMailingAddresses
    ) {
      return <GenericLoading isFullScreen={false} />;
    }
    if (Array.isArray(children)) {
      return children?.filter((child) => child.props.keyName === state?.currentScreen);
    }
    return [children]?.filter((child) => child.props.keyName === state?.currentScreen);
  }, [
    cardProvider,
    children,
    state?.currentScreen,
    isLoadingCardStatus,
    isLoadingMailingAddresses,
    locationState?.initScreen,
  ]);

  const closeCardSettings = () => history.push('/dashboard/card/details');

  return (
    <div className="d-flex flex-row main-layout">
      {isBrowser && !state.termsOpened && (
        <div
          className="position-absolute"
          onClick={closeCardSettings}
          onKeyDown={closeCardSettings}
          role="button"
          style={{ top: '4%', right: '3%', zIndex: 100 }}
          tabIndex={-1}>
          <i
            className="close-btn cursor-pointer icon icon-close-other text-dark text-f4"
            aria-label="Close"
          />
        </div>
      )}
      <div className="d-flex flex-column flex-fill align-items-center h-100vh position-relative">
        <div
          className={`d-flex flex-column w-100 position-relative h-100 ${className} ${
            isMobile ? 'px-3' : ''
          }`}
          style={{
            paddingTop: isBrowser ? '6rem' : '2rem',
            maxWidth: '33.5rem',
            transitionProperty: 'margin',
            transitionDuration: '300ms',
          }}>
          {renderedComponent}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;

MainLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.string,
};
